export const rolesData = [
  // { name: '', value: '' },
  { name: 'Not Selected', value: 'not_selected' },
  { name: 'Veterinarian', value: 'veterinarian' },
  { name: 'Veterinary Tech/Nurse', value: 'veterinary_tech_nurse' },
  { name: 'Practice Manager', value: 'practice_manager' },
  { name: 'Practice Support Staff', value: 'practice_support_staff' },
  { name: 'Student', value: 'student' },
  { name: 'Other', value: 'other' },
];
